import React from "react";
import { Typography, Box, Button } from "@mui/material";
import { useNavigate } from "react-router";
import { NotEligibleForPaymentArrangements } from "../../../SharedComponents/contents";
import { useCustomNavigate } from "../../../Utils/navigationUtils";
import { formatDateWithOffset, replaceJSX } from "../../../Utils/utils";
import { useAppSelector } from "../../../hooks";

interface bsProps {
  onClose: any;
  date: any
}
;
function InvoicePending({ onClose,date }: bsProps) {
  const notEligibleForPaymentArrangements : any = NotEligibleForPaymentArrangements();
  const JSONcontent : any = notEligibleForPaymentArrangements?.entry;
  const navigate = useNavigate();
  const { customNavigate } = useCustomNavigate();
  const prePayAccount = JSONcontent?.prePayAccount;
  const {fetchPlan} = useAppSelector(
      (state:any) => state?.nonAuthPaymentArrangement
    );
 const newDate= fetchPlan && formatDateWithOffset(fetchPlan)
  return (
    <Box className="nonAuthEligibleModalBox">
      <Typography className="nonAuthEligibleModalTitle">
        {"Your bill is still processing."}
      </Typography>
      <Typography className="nonAuthEligibleModalDescription">
        {`You can’t set up a payment arrangement while your bill is processing. Please come back on ${newDate}, once your bill is ready, to create one.`}
      </Typography>

      <Box className="buttonBoxContainer">
        <Button
          variant="outlined"
          color="primary"
          onClick={() => onClose()}
          className="secondary nonAuthEligibleBtn"
          sx={{ textTransform: "none" }}
        >
          {prePayAccount?.closeButton}
        </Button>
        <Button
          variant="contained"
          color="primary"
          className="primary nonAuthEligibleBtn"
          sx={{ textTransform: "none" }}
          onClick={() => customNavigate("/login")}
        >
          {prePayAccount?.signInButton}
        </Button>
      </Box>
    </Box>
  );
}

export default InvoicePending;
